import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import React from "react"
import {number, translate} from '../../../filters'
import Trans from '../../Trans'

type HighestBidderCountStatisticProps = {
  highestBidder: number
}

export default class HighestBidderCountStatistic extends React.Component<HighestBidderCountStatisticProps> {
  render() {
    return (
      <div className='statistic_box rounded'>
        <div className='statistic_box_body'>
          <h2>{translate("Höchstbietender")}</h2>
          <p>{translate("Anzahl Fahrzeuge, bei denen Sie momentan Höchstbietender sind.")}</p>
          <div className='stat'>
            <Icon icon="gavel" className="fa-4x mr-4 fa-fw"/>
            <span className="font-semibold text-2xl">{number(this.props.highestBidder, 0, 'x')}</span>
          </div>
        </div>
      </div>
    )
  }
}
